import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios, { CancelToken } from "axios";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import { GetFloorPlanTemplate, IFloorPlanTemplate } from "api/rpc/2024-04/facilityAdmin/tables/tables";

export default function FloorPlanTemplates() {
  const history = useHistory();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [floorPlanTemplates, setFloorPlanTemplates] = useState<IFloorPlanTemplate[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadFloorPlanTemplates(source.token);
    return () => source.cancel();
  }, []);

  async function loadFloorPlanTemplates(token?: CancelToken) {
    if (floorPlanTemplates !== undefined) {
      setFloorPlanTemplates(undefined);
    }
    const res = await GetFloorPlanTemplate({}, token ? false : true, token);

    if (token && token.reason) {
      return;
    }
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Failed to load floor plans")));
    }

    setFloorPlanTemplates(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("Create"),
    action: () => history.push("/admin/settings/floor-plan-template/new"),
  };

  return (
    <Page title={t("Floor Plan Templates")} narrow primaryAction={primaryAction}>
      <DataTable columns={[{ label: t("Title") }]} loading={floorPlanTemplates === undefined}>
        {floorPlanTemplates?.map(template => (
          <tr
            key={template.id}
            className="clickable"
            onClick={() => history.push("/admin/settings/floor-plan-template/" + String(template.id))}
          >
            <td>{template.title}</td>
          </tr>
        ))}
      </DataTable>
    </Page>
  );
}
